
import './Kontakt.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      
        <div className='main'>
            <Container>
              <Container style={{width:"65%"}}>
                <div className='holder' style={{}}>
                <div className='flex-item'>
                  <h2>Kontakt</h2>
                  <a className='flex-item-a' href='mailto:info@blaudent.ee'>Email: info@blaudent.ee</a>
                  <a className='flex-item-a' href='tel:+37255661618' style={{textWrap:"stable"}}>Telefon: +372 5566 1618</a>
                  
                </div>
                <div className='flex-item'>
                  <h2>Aadress</h2>
                  <a style={{width:"150px"}} className='flex-item-a' href='https://maps.app.goo.gl/tMeF6CiTMx7RUEYC6'>Roopa 12A, Tallinn</a>
                </div>
                <div className='flex-item'>
                  <h2>Avatud</h2>
                  <p>E 9.00-15.00</p>
                  <p>T 9.00-16.00</p>
                  <p>K 9.00-15.00</p>
                  <p>R üle nädala 9.00-14.00</p>
                </div>
              </div>
              </Container>

              <Container>
                <hr></hr>
            </Container>

              <div style={{display:"flex", justifyContent:"center", flexWrap:"wrap"}}>
                <div className='flex-item' style={{width:"65%"}}>
                  <h2 style={{textAlign:"center"}} id='KKK'>KKK</h2>
                  <div className='fixed-a'>
                    <a href='/failid/KKK.pdf' className='fixed-a' style={{textAlign:"start", textDecoration:"dashed", color:"AccentColor"}}>KKK.pdf</a>
                  </div>
                  
                </div>

                </div>
              <iframe width="100%" style={{borderRadius:"16px", padding:"0", minHeight:"350px"}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2029.1338349517648!2d24.72545251306723!3d59.43084240278487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46929484d01142dd%3A0xc4cc6ad1c13957b4!2sBlaudent%20O%C3%9C!5e0!3m2!1sen!2sus!4v1756212346673!5m2!1sen!2sus"></iframe>
            </Container>
        </div>
    );
}